
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artykuly/[slug]",
      function () {
        return require("private-next-pages/artykuly/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artykuly/[slug]"])
      });
    }
  